import { render, staticRenderFns } from "./PartnersModal.vue?vue&type=template&id=4ace8fc0&scoped=true&"
import script from "./PartnersModal.vue?vue&type=script&lang=js&"
export * from "./PartnersModal.vue?vue&type=script&lang=js&"
import style0 from "./PartnersModal.vue?vue&type=style&index=0&id=4ace8fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ace8fc0",
  null
  
)

export default component.exports